export default __webpack_public_path__ + "static/media/Willie_avatar.aed5c4bc.png";